import store from '@/store/global.store';
import { PermissionKey } from '@/enums/PermissionKey';

class NavigationService {
    getDefaultRoute = () => {
        return '/companies';
    };

    routeHasPermissions = (permissionKey, allowReadOnly) => {
        const { permissions = {}, isReadOnly } = store.getters.currentUser() || {};

        // If the route allow read-only users, check if the user has access
        const canAccess = isReadOnly ? allowReadOnly === true : true;
        if (!canAccess) return false;

        // check permissions
        switch (permissionKey) {
            case PermissionKey.UserAdministrator:
                return permissions.hasUserAdministratorAccess;

            case PermissionKey.Billing:
                return permissions.hasBillingAccess;

            case PermissionKey.Demo:
                return permissions.hasDemoAccess;

            case PermissionKey.TinyPumper:
                return permissions.hasTinyPumperAccess;

            case PermissionKey.Experimental:
                return permissions.hasExperimentalAccess;

            case PermissionKey.GearUp:
                return permissions.hasGearUpAccess;

            default:
                return true;
        }
    };
}

export default new NavigationService();
